import React, { useState } from "react";
import { Container, Row, Col, Button, Form } from "react-bootstrap";
import * as Yup from "yup"; // For validation
import "./Contact.css";
import { contactusUser } from "../../redux/slice/authSlice";
import { useDispatch } from "react-redux";

export const Contact = ({content}) => {
  const dispatch = useDispatch();
  const [success, setSuccess] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [formErrors, setFormErrors] = useState({});

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // Yup validation schema
  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    email: Yup.string().email("Invalid email address").required("Email is required"),
    phone: Yup.string().required("Phone is required"),
    message: Yup.string().required("Message is required"),
  });

  const contactUsFormHandler = async (e) => {
    e.preventDefault();

    try {
      await validationSchema.validate(formData, { abortEarly: false });
      dispatch(contactusUser(formData));
      setSuccess(true);
      setTimeout(() => {
        setSuccess(false);
      }, 2000);
      setFormData({
        name: "",
        email: "",
        phone: "",
        message: "",
      });
    } catch (error) {
      const errors = {};
      error.inner.forEach((e) => {
        errors[e.path] = e.message;
      });
      setFormErrors(errors);
    }
  };

  return (
    <section className="keyzi_content--wrapper" id="contact-us">
      <Container>
        <div className="keyzi_content--inner">
          <Row>
            {/* Instructor Info Section */}
            <Col md={6}>
              <div className="card p-4">
              {content?.[0]?.description && <div dangerouslySetInnerHTML={{ __html: content?.[0]?.description }} /> }
                <Button variant="primary">Careers Enquiries</Button>
              </div>
            </Col>

            {/* Contact Form Section */}
            <Col md={6}>
              <div className="card p-4" id="contact-form">
                <h4>Contact Us</h4>
                <Form onSubmit={contactUsFormHandler}>
                  <Form.Group controlId="name">
                    <Form.Label>Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      isInvalid={!!formErrors.name}
                    />
                    <Form.Control.Feedback type="invalid">
                      {formErrors.name}
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group controlId="email">
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      isInvalid={!!formErrors.email}
                    />
                    <Form.Control.Feedback type="invalid">
                      {formErrors.email}
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group controlId="phone">
                    <Form.Label>Phone Number</Form.Label>
                    <Form.Control
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                      isInvalid={!!formErrors.phone}
                    />
                    <Form.Control.Feedback type="invalid">
                      {formErrors.phone}
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group controlId="message">
                    <Form.Label>Message</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={4}
                      name="message"
                      value={formData.message}
                      onChange={handleInputChange}
                      isInvalid={!!formErrors.message}
                    />
                    <Form.Control.Feedback type="invalid">
                      {formErrors.message}
                    </Form.Control.Feedback>
                  </Form.Group>
                  {success && <div className="mt-3 text-success">Form submitted successfully!</div>}
                  <Button type="submit" variant="primary" className="mt-3">
                    Submit
                  </Button>
                </Form>

                
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
};
